import { Injectable } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/auth";
import { auth } from "firebase/app";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private afb: AngularFireAuth) { }

  persistenceAuthLocal() {
    return this.afb.auth.setPersistence(auth.Auth.Persistence.LOCAL);
  }

  persistenceAuthSession() {
    return this.afb.auth.setPersistence(auth.Auth.Persistence.SESSION);
  }

  loginWithEmail(email: string, password: string) {
    return this.afb.auth.signInWithEmailAndPassword(email, password);
  }
  registerWithEmail(email: string, password: string) {
    return this.afb.auth.createUserWithEmailAndPassword(email, password);
  }
  getStatus() {
    return this.afb.authState;
  }
  logout() {
    return this.afb.auth.signOut();
  }
  resetPassword(email: string) {
    return this.afb.auth.sendPasswordResetEmail(email);
  }
  sendEmailVerification() {
    return this.afb.auth.currentUser.sendEmailVerification();
  }
}
